import {
    getDeviceList,
    addDevice,
    updateDevice,
    deleteDevice,
    getDeviceDetail,
    addDeviceVPS,
    getDeviceVPSDetail,
    updateDeviceVPS,
    deleteDeviceVPS,
    getVPSInforByDevice,
} from "@/api/deviceMaster";
  
const actions = {
        getDeviceList({ commit, state }, payload) {
            return new Promise((resolve, reject) => {
                getDeviceList(payload)
                    .then(response => {
                        const data = response.data;
                        resolve(data); 
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        getDeviceDetail({ commit, state }, deviceCode) {
            return new Promise((resolve, reject) => {
                getDeviceDetail(deviceCode)
                    .then(response => {
                        const data = response.data;
                        resolve(data); 
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        addDevice({ commit, state }, payload) {
            return new Promise((resolve, reject) => {
                addDevice(payload)
                    .then(response => {
                        const data = response.data;
                        resolve(data); 
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        updateDevice({ commit, state }, payload) {
            return new Promise((resolve, reject) => {
                updateDevice(payload)
                    .then(response => {
                        const data = response.data;
                        resolve(data); 
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        deleteDevice({ commit, state }, deviceCode) {
            return new Promise((resolve, reject) => {
                deleteDevice(deviceCode)
                    .then(response => {
                        const data = response.data;
                        resolve(data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        addDeviceVPS({ commit, state }, payload) {
            return new Promise((resolve, reject) => {
                addDeviceVPS(payload)
                    .then(response => {
                        const data = response.data;
                        resolve(data); 
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        getDeviceVPSDetail({ commit, state }, deviceCode) {
            return new Promise((resolve, reject) => {
                getDeviceVPSDetail(deviceCode)
                    .then(response => {
                        const data = response.data;
                        resolve(data); 
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        updateDeviceVPS({ commit, state }, payload) {
            return new Promise((resolve, reject) => {
                updateDeviceVPS(payload)
                    .then(response => {
                        const data = response.data;
                        resolve(data); 
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        deleteDeviceVPS({ commit, state }, deviceCode) {
            return new Promise((resolve, reject) => {
                deleteDeviceVPS(deviceCode)
                    .then(response => {
                        const data = response.data;
                        resolve(data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        getVPSInforByDevice({ commit, state }, deviceCode) {
            return new Promise((resolve, reject) => {
                getVPSInforByDevice(deviceCode)
                    .then(response => {
                        const data = response.data;
                        resolve(data); 
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
    };
  
  const state = () => ({});
  const getters = {};
  const mutations = {};
  
  export default {
      namespaced: true,
      state,
      getters,
      actions,
      mutations
  }
  
  